module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-room-5.6f953488.jpg";